import { lazy } from 'react'

export const PageAtlasSnezhnyjPokrovOtlojeniaAsync = lazy(
  () => import('./page_atlas_snezhnyj-pokrov-otlojenia')
)
